import { logout } from "@cpj-ai/panel-npm-package";
import { useGetProfileQuery } from "@graphql/generated";
import { useProfileStore } from "@store/useProfileStore";
import { useEffect } from "react";

export const useProfile = () => {
  const { setProfile, ...profile } = useProfileStore();
  const { data: profileData, loading, refetch } = useGetProfileQuery();

  const fetchProfile = () => {
    refetch();
  };

  useEffect(() => {
    if (!loading) {
      if (profileData) {
        setProfile(profileData);
      } else {
        logout();
      }
    }
  }, [loading, profileData, setProfile]);

  return { profile, setProfile, fetchProfile, loading };
};
